module.exports = __webpack_public_path__ + "static/img/xq-3.484ea79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xq-3.png
// module id = 7in3
// module chunks = 1